import { JiraAuthStatus } from '../types';

const JIRA_AUTH_KEY = 'jira_auth';

export const jiraAuthStorage = {
  set: (authData: JiraAuthStatus): void => {
    localStorage.setItem(JIRA_AUTH_KEY, JSON.stringify(authData));
  },

  get: (): JiraAuthStatus => {
    const data = localStorage.getItem(JIRA_AUTH_KEY);
    if (data) {
      try {
        const parsed = JSON.parse(data);
        // Redux actions.js записывает примитив (true/false),
        // а jiraAuthStorage.set() записывает объект { is_authenticated, jira_base_url }
        if (typeof parsed === 'object' && parsed !== null) {
          return {
            is_authenticated: Boolean(parsed.is_authenticated),
            jira_base_url: parsed.jira_base_url,
          };
        }
        return { is_authenticated: Boolean(parsed) };
      } catch {
        // Значение не является валидным JSON (например, просто строка "true"/"false")
        return { is_authenticated: data === 'true' };
      }
    }
    return { is_authenticated: false };
  },

  remove: (): void => {
    localStorage.removeItem(JIRA_AUTH_KEY);
  },

  has: (): boolean => {
    const data = jiraAuthStorage.get();
    return data.is_authenticated;
  },

  clear: (): void => {
    localStorage.removeItem(JIRA_AUTH_KEY);
  },
};
